import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, signal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ParametriInputSelectComponent } from 'src/app/modules/parametri/components/parametri-input-select/parametri-input-select.component';
import { ParametriSearchSelectComponent } from 'src/app/modules/parametri/components/search-select/search-select.component';
import { IParametro } from 'src/app/modules/parametri/parametri.model';
import { InputDateComponent } from 'src/app/shared/components/inputs/input-date/input-date.component';
import { InputDatetimeComponent } from 'src/app/shared/components/inputs/input-datetime/input-datetime.component';
import { InputNumberComponent } from 'src/app/shared/components/inputs/input-number/input-number.component';
import { InputSelectComponent } from 'src/app/shared/components/inputs/input-select/input-select.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import {  ReactiveFormsModule } from '@angular/forms';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from "@angular/material/form-field";@Component({
  selector: 'app-dati-controllo-row-template',
  standalone: true,
  imports: [
    CommonModule,
    InputTextComponent,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelect,
    MatSelectModule,
    ReactiveFormsModule,
    InputDateComponent,
    InputDatetimeComponent,
    InputNumberComponent,
    InputSelectComponent,
    ParametriSearchSelectComponent,
    ParametriInputSelectComponent
  ],
  templateUrl: './dati-controllo-row-template.component.html',
  styleUrl: './dati-controllo-row-template.component.css',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatiControlloRowTemplateComponent implements OnInit { //} AfterViewInit {
  @Input() element!: AbstractControl;
  @Input() list: any[] = []
  searchComponent = ParametriSearchSelectComponent;
  item?: IParametro = undefined;

  ngOnInit(): void {
    
    this.item = this.list.find((parametro) => parametro.id === this.element.get('parametroId')?.value)
  
    this.element.get('parametroId')?.valueChanges.subscribe((value) => {
 
      this.item = this.list.find((parametro) => parametro.id === value)
     
    })
  }
  setValueParametroLoq(element:any){

    if(element.get("valoreLoq").value=='<'){
        this.element.get('valoreRapportoProva')?.setValue(null)
    }
    else if(element.get("valoreLoq").value==''){
      this.element.get('valoreLoq')?.setValue(null)
      this.element.get('loq')?.setValue(null)
    }
  }
  setValueParametroLfs(element:any){
    if(element.get("valoreLfs").value=='>'){
      this.element.get('valoreRapportoProva')?.setValue(null)
    }
    else if(element.get("valoreLfs").value==''){
      this.element.get('valoreLfs')?.setValue(null)
      this.element.get('lfs')?.setValue(null)
    }
  }
  toFormGroup(control: AbstractControl): FormGroup {
    this.setValueParametroLoq(control)
    this.setValueParametroLfs(control)
    return control as FormGroup;
  }

}
